import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DataService {
  tyFilter = new BehaviorSubject<string>("post");
  accounts = new BehaviorSubject<any>(null);
  // có thể subcribe theo dõi thay đổi value của biến này thay cho messageSource

  constructor() { }
 
  // method này để change source message 
  setData(tyFilter) {
    this.tyFilter.next(tyFilter);
  }
  getData()
  {
      return this.tyFilter.asObservable();;
  }
  setDataAcounts(accounts) {
    this.accounts.next(accounts);
  }
  getDataAcounts()
  {
      return this.accounts.asObservable();;
  }
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/search-filter/search-filter.service.ts